<div class="progress">
    <div class="progress-bar bg-success rounded-0" role="progressbar" aria-label="Enrollment progress"
        [attr.aria-valuenow]="widthAria" aria-valuemin="0" aria-valuemax="100" [ngStyle]="{ 'width': width }">
        {{ width }}
    </div>      
 </div>  
